/**
 * Social URLs and card images for the home “Watch & follow” section.
 * Swap the image paths for your own assets under public/ (e.g. /assets/img/...).
 */
export const FACEBOOK_PAGE_URL = 'https://www.facebook.com/share/1HgBRKwosv/'
export const YOUTUBE_CHANNEL_URL = 'https://www.youtube.com/@urumavahini'

/** Hero-style image for the YouTube card */
export const YOUTUBE_CARD_IMAGE = '/assets/img/normal/about_1_1.jpg'
/** Hero-style image for the Facebook card */
export const FACEBOOK_CARD_IMAGE = '/assets/img/normal/about_1_2.jpg'
